import angular from "angular";

angular
    .module('app')
    .component('courseGroupStudentsAttachModal', {
        template: require('./course-group-students-attach-modal.html'),
        controller: ['$http', 'ErrorResponseParser', 'Notifier', '$scope', 'moment', controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller($http, ErrorResponseParser, Notifier, $scope, moment) {

    let $ctrl = this;

    $ctrl.page = 1;
    $ctrl.search = null;
    $ctrl.totalSelect = false;
    $ctrl.selectedUsers = [];

    $ctrl.$onInit = function () {
        $ctrl.course = $ctrl.resolve.course;
        $ctrl.courseGroup = $ctrl.resolve.courseGroup;
        $ctrl.getUsers();
    };

    $ctrl.doFilter = function () {
        $ctrl.page = 1;
        $ctrl.getUsers();
    };

    $ctrl.getUsers = function () {
        $http
            .get(`/admin/courses/get-users`, {
                params: {
                    page: $ctrl.page,
                    per_page: $ctrl.perPage,
                    search: $ctrl.search,
                    course_id: $ctrl.course.id,
                }
            })
            .then(
                function (response) {
                    $ctrl.users = response.data.data;
                    $ctrl.total = response.data.total;
                    $ctrl.users.forEach(function (user) {
                        let existsInd = $ctrl.selectedUsers.findIndex(v => v.id == user.id);
                        user.isSelected = existsInd != -1;
                    });
                },
                function (error) {
                }
            );
    };

    $ctrl.userSelected = function (user) {
        if (user.isSelected) {
            $ctrl.selectedUsers.push(user);
        } else {
            delUserFromSelected(user);
        }
    };

    $ctrl.totalSelectChanged = function () {
        if ($ctrl.totalSelect) {
            $ctrl.users.forEach(function (user) {
                if (!user.course_exists && !user.isSelected) {
                    user.isSelected = true;
                    $ctrl.selectedUsers.push(user);
                }
            });
        } else {
            $ctrl.users.forEach(function (user) {
                if (!user.course_exists && user.isSelected) {
                    user.isSelected = false;
                    delUserFromSelected(user);
                }
            });
        }
    };

    function delUserFromSelected(user) {
        let existsInd = $ctrl.selectedUsers.findIndex(v => v.id == user.id);
        if (existsInd != -1) {
            $ctrl.selectedUsers.splice(existsInd, 1);
        }
    }

    $ctrl.delSelectedUser = function (user) {
        user.isSelected = false;
        delUserFromSelected(user);
    };

    $ctrl.pageChanged = function () {
        $ctrl.totalSelect = false;
        $ctrl.getUsers();
    };

    $ctrl.submit = function () {

        let userIds = [];

        $ctrl.selectedUsers.forEach(v => userIds.push(v.id));

        $ctrl.loading = true;

        $http
            .post(`/admin/course-groups/${$ctrl.courseGroup.id}/attach-students`, {user_ids: userIds})
            .then(
                function (response) {
                    $ctrl.loading = false;
                    Notifier.success('Студенты успешно добавлены', 3);
                    $ctrl.close({$value: $ctrl.selectedUsers});
                },
                function (error) {
                    $ctrl.loading = false;
                    ErrorResponseParser.parse(error);
                }
            );
    };

}
